import React, {useState} from "react";
import {
    AdjustmentsHorizontalIcon,
    Bars3BottomRightIcon,
    NewspaperIcon,
} from "@heroicons/react/24/outline";
import {SortData} from "@/components/utils/Product-sort-data";
import {SortDataMobile} from "@/components/utils/Product-sort-data-mobile";
import {toPersianDigits} from "@/components/utils/PersianNumber";

// import LPC from "@/components/landing/LPCCARD";


interface BaseItem {
    id: number;
}

interface ItemListProps<T extends BaseItem> {
    data: T[] | null;
    count: number;
    orderOptions: { key: string; name: string }[];
    setOrder: React.Dispatch<React.SetStateAction<string>>;
    loading: boolean;
    // onFavoriteChanged?: () => void;
    initialSelected?: string;
    initialSelectedName?: string;
    setIsOpenFilters: React.Dispatch<React.SetStateAction<boolean>>;
    renderItem: (item: T) => React.ReactNode;
}

const ProductList = <T extends BaseItem, >({
                                               data,
                                               count,
                                               orderOptions,
                                               setOrder,
                                               loading,
                                               // onFavoriteChanged,
                                               initialSelected,
                                               initialSelectedName,
                                               setIsOpenFilters,
                                               renderItem
                                           }: ItemListProps<T>) => {
    const [isOpenSort, setIsOpenSort] = useState(false);
    const [selectedName, setSelectedName] = useState(
        initialSelectedName ?? ""
    );

    return (
        <div className="w-full">
            {/* Desktop */}
            <div
                className="hidden lg:flex justify-between w-full items-center font-bold text-xs text-gray-500 px-4 lg:px-0">
                <div className="inline-flex">
                    <Bars3BottomRightIcon className="size-4 ml-1 lg:ml-2"/>
                    <p className="ml-2 sm:ml-4 text-black">مرتب‌سازی:</p>
                    <SortData
                        orderList={orderOptions}
                        setOrder={setOrder}
                        initialSelected={initialSelected}
                    />
                </div>
                {count > 0 && count && (
                    <div>{toPersianDigits(count)} محصول</div>
                )}
            </div>

            {/* Mobile */}
            <div className="flex lg:hidden justify-between w-full items-center font-bold text-xs text-gray-500 px-4">
                <div className="inline-flex">
                    <button
                        type="button"
                        className="inline-flex"
                        onClick={() => setIsOpenSort(true)}
                    >
                        <Bars3BottomRightIcon className="size-4 ml-1 lg:ml-2"/>
                        <p className="ml-2 sm:ml-4 mt-0.5">
                            {selectedName || "مرتب‌سازی"}
                        </p>
                    </button>

                    <SortDataMobile
                        orderList={orderOptions}
                        setOrder={setOrder}
                        initialSelected={initialSelected}
                        isOpen={isOpenSort}
                        setIsOpen={setIsOpenSort}
                        onClose={() => setIsOpenSort(false)}
                        selectedName={setSelectedName}
                    />

                    <button
                        type="button"
                        className="inline-flex items-center hover:cursor-pointer mx-3"
                        onClick={() => setIsOpenFilters(true)}
                    >
                        <AdjustmentsHorizontalIcon className="size-4 ml-1 lg:ml-2"/>
                        <p className="ml-2 sm:ml-4 mt-1">فیلترها</p>
                    </button>
                </div>
                {count > 0 && count && (
                    <div>{toPersianDigits(count)} محصول</div>
                )}
            </div>

            <hr className="border-t border-gray-300 mt-2 mb-3 mx-4 lg:mx-0"/>

            {/* List */}
            {data && data.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 px-4 lg:px-0">
                    {data.map((item) => (
                        <React.Fragment key={item.id}>
                            {renderItem(item)}
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                !loading && (
                    <div className="flex flex-col p-4 mt-8 items-center text-gray-500 space-y-4">
                        <NewspaperIcon className="size-12"/>
                        <div>هیچ موردی یافت نشد.</div>
                    </div>
                )
            )}
        </div>
    );
};

export default ProductList;
